export enum ProductTypeEnum {
  GBM = 'GBM',
  Fertilizer = 'Fertilizer',
}

export enum SourceEnum {
  Manual = 'Manual',
  AgrifirmArableLegacySAP = 'AgrifirmArableLegacySAP',
}

export enum UnitOfMeasurementEnum {
  G = 'G',
  KG = 'KG',
  T = 'T',
  ML = 'ML',
  L = 'L',
  ST = 'ST',
}

export enum StateOfMatterEnum {
  Solid = 'Solid',
  Liquid = 'Liquid',
}

export enum SkalTypeEnum {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum FertilizerTypeEnum {
  Synthetic = 'Synthetic',
  Animal = 'Animal',
  OtherOrganic = 'OtherOrganic',
  Compost = 'Compost',
  Lime = 'Lime',
  BioStimulator = 'BioStimulator',
}

export interface NutritionalCompositionData {
  n?: number;
  p2O5?: number;
  k2O?: number;
  na2O?: number;
  mgO?: number;
  caO?: number;
  sO3?: number;
  b?: number;
  mn?: number;
  fe?: number;
  zn?: number;
  cu?: number;
  co?: number;
  [key: string]: number;
}

export interface NitrogenEffectivenessData {
  january: number;
  february: number;
  march: number;
  april: number;
  may: number;
  june: number;
  july: number;
  august: number;
  september: number;
  october: number;
  november: number;
  december: number;
}

export interface ProprietaryCustomerInformationData {
  cropYear: number;
  originalCropAidId: number;
  expirationCropYear?: number;
}

export interface FertilizerData {
  density: number;
  ediCode: number;
  fertilizerType: FertilizerTypeEnum;
  nutritionalComposition: NutritionalCompositionData;
  skalType: SkalTypeEnum;
  stateOfMatter: StateOfMatterEnum;
  nitrogenEffectiveness: NitrogenEffectivenessData;
  proprietaryCustomerInformation: ProprietaryCustomerInformationData;
}

export interface CropProtectionData {
  activeIngredient: string;
  admissions: Admission[];
}

export interface CropAid {
  id: number;
  name: string;
  productType: ProductTypeEnum;
  source: SourceEnum;
  unitOfMeasurement: UnitOfMeasurementEnum;
  indicativePrice: number;
  isActive: boolean;
  isCropProtection: boolean;
  isFertilizer: boolean;
  fertilizer: FertilizerData;
  isHidden: boolean;
  cropProtection: CropProtectionData;
}

export interface ProprietaryFertilizerData {
  id: number;
  originalCropAidId: number;
  name: string;
  expirationCropYear?: number;
  nutritionalComposition: NutritionalCompositionData;
}

export interface UpsertProprietaryFertilizerData {
  id: number;
  name: string;
  nutritionalComposition: NutritionalCompositionData;
  proprietaryCustomerInformation: ProprietaryCustomerInformationData;
}

export interface Admission {
  id: number;
  number: string;
}
